export const name = 'wixCustomElementComponent' as const
export const WixCustomElementComponentAPISymbol = Symbol('WixCustomElementComponentAPISymbol')
